<template>
  <div id="contenedor-listado-mobiles">
    <template
      v-for="(contrato, index) in listadoContratistas">
      <v-card
        :key="index"
        class="mb-2">
        <v-card-title
          class="justify-space-between">
          <div
            class="d-inline-block text-truncate">
            {{ contrato.numero }}
          </div>
          <div
            class="d-inline-block">
            <opciones
              :id="contrato.id">
            </opciones>
          </div>
        </v-card-title>
        <v-card-text>
          {{ contrato.meta }}
        </v-card-text>
      </v-card>
    </template>
  </div>
</template>

<script>
import Opciones from './Opciones.vue';

export default {
  name: 'ListadoMobiles',
  props: {
    listadoContratistas: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">

</style>
